import type { CommunicationsMessages } from "./messages.en";

export const communicationsNavEs: Partial<Record<keyof CommunicationsMessages, string>> = {
  "comms.phone.setupRequired": "Conecte el sistema telefónico del club y guarde su extensión en Ajustes del club para registrar llamadas y mensajes.",
  "comms.mail.title": "Enviar correo al socio",
  "comms.mail.hint": "Envíe desde su cuenta de trabajo conectada y guarde una copia en el historial del socio.",
  "comms.mail.connectHint": "Conecte su buzón Microsoft antes de enviar. Un administrador debe vincular su identidad de trabajo.",
  "comms.mail.connect": "Conectar mi buzón Microsoft",
  "comms.mail.disconnect": "Desconectar mi buzón",
  "comms.mail.connectFailed": "No se pudo iniciar la conexión del buzón.",
  "comms.mail.send": "Enviar correo",
  "comms.mail.required": "Introduzca un asunto y un mensaje.",
  "comms.mail.to": "Para",
  "comms.mail.from": "De",
  "comms.mail.subject": "Asunto",
  "comms.mail.body": "Mensaje",
  "comms.mail.permission": "Su rol o licencia no permite enviar correo.",
  "comms.mail.accepted": "Enviado al servicio de correo y registrado aquí. La entrega no está confirmada.",
  "comms.mail.failed": "El servicio rechazó el mensaje. Se registró como fallido.",
  "comms.mail.unknown": "El resultado es incierto. Revise Elementos enviados antes de volver a intentarlo. ClubCore no reenviará automáticamente.",

  "comms.module": "Teléfono y mensajes de texto",
  "comms.nav.messages": "Mensajes telefónicos",
  "comms.nav.log": "Registro de llamadas",
  "comms.nav.settings": "Números de teléfono",
  "comms.nav.texts": "Mensajes de texto",
  "comms.texts.unreadBadge_one": "{count} mensaje de texto sin leer",
  "comms.texts.unreadBadge_other": "{count} mensajes de texto sin leer",

  "comms.phone.options": "Llamar o enviar un mensaje de texto",
  "comms.phone.call": "Llamar",
  "comms.phone.text": "Mensaje de texto",
  "comms.phone.calling": "Llamando…",
  "comms.phone.ringing": "Su teléfono está sonando: descuelgue para conectar con {number}.",
  "comms.phone.error.not_a_phone_number": "No se puede llamar a este número.",
  "comms.phone.error.extension_required": "Guarde primero su extensión (Mi teléfono en Ajustes del club) y vuelva a intentarlo.",
  "comms.phone.error.phone_not_configured": "La centralita no está configurada. Consulte a un responsable.",
  "comms.phone.error.generic": "No se pudo hacer la llamada. Vuelva a intentarlo.",
  "comms.phone.dismiss": "Cerrar",
};

export const communicationsEs: Partial<Record<keyof CommunicationsMessages, string>> = {

  "comms.channel.call": "Llamada",
  "comms.channel.text": "Mensaje de texto",
  "comms.channel.email": "Correo electrónico",
  "comms.channel.note": "Nota",
  "comms.direction.inbound": "Entrante",
  "comms.direction.outbound": "Saliente",
  "comms.direction.internal": "Interna",
  "comms.status.answered": "Contestada",
  "comms.status.missed": "Perdida",
  "comms.status.voicemail": "Buzón de voz",
  "comms.status.sent": "Enviado",
  "comms.status.delivered": "Entregado",
  "comms.status.failed": "Fallido",
  "comms.status.received": "Recibido",
  "comms.status.logged": "Registrado",
  "comms.match.exact_contact": "Un número guardado de un socio",
  "comms.match.staff_link": "Vinculada por el personal",
  "comms.match.none": "Sin coincidencia",
  "comms.urgency.low": "Baja",
  "comms.urgency.normal": "Normal",
  "comms.urgency.urgent": "Urgente",
  "comms.state.open": "Abierto",
  "comms.state.done": "Terminado",

  "comms.picker.hint": "Escriba al menos dos letras de un nombre, o un número de socio.",
  "comms.picker.none": "Ningún socio coincide.",
  "comms.picker.change": "Cambiar",

  "comms.messages.title": "Mensajes telefónicos",
  "comms.messages.subtitle": "Mensajes tomados para el personal y los departamentos, y quién los ha atendido.",
  "comms.messages.new": "Nuevo mensaje telefónico",
  "comms.messages.tab.mine": "Para mí",
  "comms.messages.tab.all": "Todos",
  "comms.messages.filter.state": "Mostrar",
  "comms.messages.filter.open": "Mensajes abiertos",
  "comms.messages.filter.done": "Mensajes terminados",
  "comms.messages.filter.any": "Abiertos y terminados",
  "comms.messages.filter.recipient": "Dejado para",
  "comms.messages.filter.anyone": "Cualquiera",
  "comms.messages.none": "Todavía no hay mensajes telefónicos",
  "comms.messages.none.hint": "Los mensajes tomados en recepción o en la tienda de golf aparecen aquí.",
  "comms.messages.noMatches": "Ningún mensaje coincide",
  "comms.messages.noMatches.hint": "Pruebe a mostrar los mensajes abiertos y terminados, o elija a otra persona.",
  "comms.messages.col.when": "Recibido",
  "comms.messages.col.from": "De",
  "comms.messages.col.about": "Sobre",
  "comms.messages.col.for": "Para",
  "comms.messages.col.message": "Mensaje",
  "comms.messages.col.status": "Estado",
  "comms.messages.col.actions": "Acciones",
  "comms.messages.unknownCaller": "Llamante desconocido",
  "comms.messages.callback": "Devolver la llamada: {number}",
  "comms.messages.doneOn": "Terminado {when}",
  "comms.messages.markDone": "Marcar como terminado",
  "comms.messages.reopen": "Reabrir",
  "comms.messages.actionFor": "{action}: mensaje de {who}",
  "comms.messages.markedDone": "Mensaje marcado como terminado.",
  "comms.messages.reopened": "Mensaje reabierto.",
  "comms.messages.form.callerName": "Nombre de quien llama",
  "comms.messages.form.callerNumber": "Número de quien llama",
  "comms.messages.form.callerNumber.hint": "Escrito de cualquier forma; se interpreta según el país del club.",
  "comms.messages.form.callback": "Teléfono para devolver la llamada (opcional)",
  "comms.messages.form.callback.hint": "Otro número para devolver la llamada, si es necesario.",
  "comms.messages.form.member": "Socio al que se refiere",
  "comms.messages.form.recipient": "Dejar para",
  "comms.messages.form.recipient.choose": "Elija una persona o un departamento",
  "comms.messages.form.recipient.staff": "Personal",
  "comms.messages.form.recipient.roles": "Departamentos",
  "comms.messages.form.recipientRequired": "Elija para quién es el mensaje.",
  "comms.messages.form.urgency": "Urgencia",
  "comms.messages.form.notes": "Mensaje",
  "comms.messages.form.notesRequired": "Escriba el mensaje.",
  "comms.messages.form.submit": "Guardar mensaje",
  "comms.messages.form.saved": "Mensaje telefónico guardado.",
  "apiError.not_a_phone_number": "Eso no es un número de teléfono.",
  "apiError.recipient_unavailable": "Ese empleado o departamento no puede recibir mensajes telefónicos en este momento. Elija otro destinatario.",
  "apiError.not_your_message": "Este mensaje es para otra persona.",

  "comms.log.title": "Registro de llamadas",
  "comms.log.subtitle": "Llamadas y mensajes de texto tal como los informa el sistema telefónico. El registro nunca se modifica; el personal puede indicar con quién fue una llamada.",
  "comms.log.tab.log": "Llamadas y mensajes",
  "comms.log.tab.unknown": "Llamantes desconocidos",
  "comms.log.filter.kind": "Tipo",
  "comms.log.filter.anyKind": "Cualquier tipo",
  "comms.log.filter.direction": "Dirección",
  "comms.log.filter.anyDirection": "Cualquier dirección",
  "comms.log.filter.number": "Número de teléfono",
  "comms.log.filter.from": "Desde la fecha",
  "comms.log.filter.to": "Hasta la fecha",
  "comms.log.filter.unmatched": "Solo llamadas sin socio vinculado",
  "comms.log.none": "Todavía no hay nada en el registro de llamadas",
  "comms.log.none.hint": "Las llamadas y los mensajes aparecen aquí cuando el sistema telefónico los informa.",
  "comms.log.noMatches": "Ninguna llamada ni mensaje coincide",
  "comms.log.noMatches.hint": "Amplíe las fechas o quite un filtro.",
  "comms.log.col.when": "Cuándo",
  "comms.log.col.kind": "Tipo",
  "comms.log.col.number": "Número",
  "comms.log.col.member": "Socio",
  "comms.log.col.duration": "Duración",
  "comms.log.col.extension": "Extensión",
  "comms.log.unknown": "Desconocido",
  "comms.log.householdOnly": "Hogar {name}",
  "comms.log.detail.callerName": "Nombre del identificador de llamadas",
  "comms.log.detail.title": "Detalles de la llamada",
  "comms.log.detail.status": "Resultado",
  "comms.log.detail.asGiven": "Número tal como se informó",
  "comms.log.detail.staff": "Miembro del personal",
  "comms.log.detail.subject": "Asunto",
  "comms.log.detail.body": "Texto",
  "comms.log.detail.summary": "Resumen",
  "comms.log.detail.recording": "Grabación",
  "comms.log.detail.openRecording": "Abrir la grabación",
  "comms.log.detail.matchedBy": "Coincidencia por",
  "comms.log.candidates": "Socios que comparten este número",
  "comms.log.candidates.count_one": "{count} socio comparte este número.",
  "comms.log.candidates.count_other": "{count} socios comparten este número.",
  "comms.log.link": "Vincular",
  "comms.log.linkTo": "Vincular esta llamada con {name}",
  "comms.log.linkHeading": "¿Quién era?",
  "comms.log.changeLink": "Cambiar quién era",
  "comms.log.linkMember": "Socio",
  "comms.log.linkToMember": "Vincular con este socio",
  "comms.log.removeLink": "Quitar el vínculo",
  "comms.log.linked": "Llamada vinculada.",
  "comms.log.unlinked": "Vínculo quitado.",

  "comms.unknown.none": "No hay llamantes desconocidos",
  "comms.unknown.none.hint": "Todos los números que llamaron o escribieron coinciden con un socio.",
  "comms.unknown.col.entries": "Llamadas y mensajes",
  "comms.unknown.col.channels": "Tipos",
  "comms.unknown.col.first": "Visto por primera vez",
  "comms.unknown.col.last": "Visto por última vez",
  "comms.unknown.link": "Vincular con un socio",
  "comms.unknown.linkFor": "Vincular {number} con un socio",
  "comms.unknown.linkTitle": "¿Quién es {number}?",
  "comms.unknown.linkBody": "Sus llamadas y mensajes anteriores sin vincular se vinculan, y los futuros coincidirán con este socio.",
  "comms.unknown.member": "Socio",
  "comms.unknown.memberRequired": "Elija un socio.",
  "comms.unknown.addContact": "Agregar también este número a los contactos del socio",
  "comms.unknown.addContact.hint": "para que figure en su ficha.",
  "comms.unknown.linkSubmit": "Vincular número",
  "comms.unknown.linked_one": "{number} vinculado con {name}; se completó {count} llamada o mensaje anterior.",
  "comms.unknown.linked_other": "{number} vinculado con {name}; se completaron {count} llamadas o mensajes anteriores.",

  "comms.timeline.title": "Historial de comunicaciones",
  "comms.timeline.none": "Todavía no hay comunicaciones vinculadas con esta persona.",
  "comms.timeline.more": "Mostrar más",

  "comms.settings.title": "Números de teléfono",
  "comms.settings.subtitle": "Cómo se interpretan los números del sistema telefónico.",
  "comms.settings.card": "País de los números de teléfono",
  "comms.settings.region": "País",
  "comms.settings.region.hint": "Los números escritos sin código de país, como 843 555 0142, se interpretan como números de este país.",
  "comms.settings.saved": "Ajustes de números de teléfono guardados.",
  "comms.region.US": "Estados Unidos",
  "comms.region.CA": "Canadá",
  "comms.region.BS": "Bahamas",
  "comms.region.BM": "Bermudas",
  "comms.region.GB": "Reino Unido",
  "comms.region.IE": "Irlanda",
  "comms.region.AU": "Australia",
  "comms.region.NZ": "Nueva Zelanda",
  "comms.region.MX": "México",

  "comms.settings.help.card": "Respuesta a HELP",
  "comms.settings.help.label": "Texto que se envía a quien escriba HELP",
  "comms.settings.help.hint": "Déjelo vacío para enviar: {text}",
  "comms.settings.help.saved": "Respuesta a HELP guardada.",

  "comms.compose.title": "Enviar un mensaje de texto a {name}",
  "comms.compose.from": "Se envía desde el número del club {number}.",
  "comms.compose.message": "Mensaje",
  "comms.compose.send": "Enviar",
  "comms.compose.sent": "Mensaje de texto enviado a {number}.",
  "comms.compose.parts_one": "{characters} caracteres · 1 parte",
  "comms.compose.parts_other": "{characters} caracteres · {count} partes",
  "comms.compose.unicode": "Los acentos fuera del juego estándar o los emojis acortan cada parte (70 caracteres).",
  "comms.compose.tooLong": "Demasiado largo: un mensaje de texto puede tener como máximo {count} partes.",
  "comms.compose.optedOut": "Este número respondió STOP el {date}. El club no puede enviarle mensajes de texto hasta que escriba START.",
  "comms.compose.optedOutUndated": "Este número respondió STOP. El club no puede enviarle mensajes de texto hasta que escriba START.",
  "comms.compose.historyHidden": "No puede ver los mensajes anteriores con este número.",
  "comms.compose.openConversation": "Abrir la conversación",
  "comms.compose.error.recipient_opted_out": "Este número respondió STOP, así que no se le pueden enviar mensajes de texto.",
  "comms.compose.error.sms_rate_limited": "Ha enviado muchos mensajes de texto en los últimos minutos. Espere un poco y vuelva a intentarlo.",
  "comms.compose.error.sms_not_available": "La centralita del club todavía no puede enviar mensajes de texto. Consulte a un responsable.",
  "comms.compose.error.text_too_long": "El mensaje de texto es demasiado largo.",
  "comms.compose.error.empty_text": "Escriba primero el mensaje.",
  "comms.compose.error.not_a_phone_number": "Este número no puede recibir mensajes de texto.",
  "comms.compose.error.generic": "El mensaje de texto no se envió. Vuelva a intentarlo.",

  "comms.thread.label": "Mensajes de texto con {name}",
  "comms.thread.none": "Todavía no hay mensajes de texto con este número.",
  "comms.thread.older": "Ver mensajes anteriores",
  "comms.thread.incoming": "De ellos",
  "comms.thread.outgoing": "Del club",
  "comms.thread.sentBy": "Enviado por {name}",
  "comms.thread.automatic": "Respuesta automática a HELP",
  "comms.thread.notSent": "No enviado: {reason}",
  "comms.thread.errorCode": "Código del operador {code}",

  "comms.texts.title": "Mensajes de texto",
  "comms.texts.subtitle": "Conversaciones por mensaje de texto con el número del club, las más recientes primero.",
  "comms.texts.list": "Conversaciones",
  "comms.texts.unreadOnly": "Solo sin leer",
  "comms.texts.none": "Todavía no hay mensajes de texto",
  "comms.texts.none.hint": "Aquí aparecen los mensajes de texto enviados y recibidos en el número del club.",
  "comms.texts.noneUnread": "No hay mensajes sin leer",
  "comms.texts.noneUnread.hint": "Todas las conversaciones están leídas.",
  "comms.texts.unread_one": "{count} sin leer",
  "comms.texts.unread_other": "{count} sin leer",
  "comms.texts.optedOut": "Dado de baja",
  "comms.texts.unknown": "Número desconocido",
  "comms.texts.you": "Usted: {text}",
  "comms.texts.pick": "Elija una conversación para leerla.",
  "comms.texts.back": "Todas las conversaciones",
  "comms.texts.openMember": "Abrir socio",
  "comms.texts.cannotSend": "Puede leer estos mensajes de texto, pero no enviarlos.",
  "comms.messages.finished": "Terminado",
  "comms.messages.general": "Mensaje general",
  "comms.messages.delete": "Eliminar",
  "comms.messages.deleteFor": "Eliminar mensaje de {who}",
  "comms.messages.deleteTitle": "¿Eliminar mensaje telefónico?",
  "comms.messages.deleteConfirm": "Este mensaje se quitará de las listas. Se conserva su historial de auditoría y un administrador del sistema puede recuperarlo.",
  "comms.messages.deleted": "Mensaje telefónico eliminado.",
  "comms.messages.callbackDue": "Devolver llamada: {when}",
  "comms.messages.form.callbackDate": "Fecha para devolver llamada (opcional)",
  "comms.messages.form.callbackTime": "Hora para devolver llamada (opcional)",
  "comms.messages.form.callbackZone": "La fecha y la hora usan la zona horaria del club: {zone}. Deje ambos campos vacíos si no hay devolución programada.",
  "comms.messages.form.callbackInvalid": "Introduzca una fecha y hora válidas. Elija una hora fuera de una hora omitida o repetida por el cambio de horario.",
  "comms.messages.form.about": "El mensaje trata de",
  "comms.messages.form.general": "Mensaje general / no socio",
  "comms.messages.form.aboutMember": "Un socio (vínculo opcional)",
  "comms.messages.form.generalHint": "Los mensajes pueden tratar de cualquier persona; el vínculo a un socio es opcional.",
};
